import {ApiMode} from '@di-nxt/resource-container';
import {Config} from './types';

const apiMode: ApiMode = 'api';

const config: Config = {
  Env: process.env.NODE_ENV,
  Api: {
    Mode: process.env.STORYBOOK_APP_API_MODE || apiMode,
    BaseUrl: process.env.REACT_APP_SHIFTER_API_BASE_URL,
    Mock: {
      FailureRate: undefined, // 2,
      RefreshTokenLifetime: undefined, // 300,
      Mode: 'generate',
      ShiftCount: [0, 2],
      TaskCount: [0, 3],
    },
  },
  Pusher: {
    ApiKey: process.env.REACT_APP_PUSHER_API_KEY,
    AuthEndpoint: process.env.REACT_APP_PUSHER_AUTH_ENDPOINT,
    Cluster: process.env.REACT_APP_PUSHER_CLUSTER!,
  },
};

export const getConfig = () => config;
